import React from 'react'
import { FieldControl } from 'spark-core-dx/components';
import { SystemTypes } from 'spark-core-dx/services';
import { useVisualFormContext } from '../../../contexts/VisualFormContext';

export const VisualType = ({ visualTypes, options }) => {
    const rawOptions = options ?? visualTypes?.map(item => ({
        Text: item?.FriendlyName ?? item?.Name ?? item?.ShortName ?? item?._id,
        Value: item?._id ?? item?.Value
    }));
    const convertedVisualTypes = rawOptions?.length
        ? rawOptions
        : [{
            Text: 'No visual types available',
            Value: '',
            Disabled: true,
        }];
    const { visualObject, setVisualTypeId } = useVisualFormContext();

    return (
        <FieldControl
            className={"visual-type-field"}
            fieldMetadata={{
                FieldType: SystemTypes.UIFieldType.ImageSelectGrid,
                DisplayName: "Visual Type",
                FieldName: "VisualTypeId",
                IsRequired: true,
                PlaceHolder: "Search visual types...",
                DataJson: convertedVisualTypes ?? [],
            }}
            groupId={"visual"}
            value={visualObject?.VisualTypeId ?? ""}
            onChange={(v) => {
                setVisualTypeId(v);
            }}
        />
    )
}
